export default "__VITE_ASSET__CqMKPsRb__"